<template>
  <article>
    <Hero heading="Thank you" :subheading="true">
      <template #subheading>
        <p>Your information has been received.</p>
      </template>
    </Hero>
  </article>
</template>

<script>
import Hero from '../components/Hero/Hero.vue';

export default {
  name: 'thank-you',
  metaInfo: {
    title: 'Thank You | Electrify America',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  components: { Hero },
};
</script>
